const Maintenance = () => {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f6f4ef",
      fontFamily: "Inter, sans-serif",
      textAlign: "center",
      padding: "20px"
    }}>
      <div>
        <h1 style={{
          fontFamily: "Playfair Display, serif",
          fontSize: "36px",
          marginBottom: "10px"
        }}>
          Anand Fashion
        </h1>

        <p style={{fontSize: "18px", marginBottom: "20px"}}>
          Website temporarily under maintenance
        </p>

        <p style={{color: "#555"}}>
          We are updating our latest fashion collections.
          Please check back shortly.
        </p>

        <p style={{marginTop: "30px", color: "#777"}}>
          For enquiries contact:
          <br />
          +91 9214456664
        </p>
      </div>
    </div>
  );
};

export default Maintenance;